var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ConfirmationModal",
    {
      attrs: {
        title: _vm.$t("ACCOUNT_BILLING_CURRENT_PRICING_MODAL_HEADER"),
        "show-confirm-button": false,
        "show-cancel-button": false
      },
      on: {
        close: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row form-group" }, [
          _c("div", { staticClass: "col-sm-6" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("ACCOUNT_BILLING_RECORDING_PRICING")) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-6" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm._f("currency")(_vm.pricingPlan.recordingCost)) +
                " /\n        " +
                _vm._s(_vm.$t("ACCOUNT_BILLING_RECORDING_MINUTE")) +
                "\n      "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row form-group" }, [
          _c("div", { staticClass: "col-sm-6" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("ACCOUNT_BILLING_ICP_PRICING")) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-6" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm._f("currency")(_vm.pricingPlan.dataEnrichmentCost)) +
                " /\n        " +
                _vm._s(_vm.$t("ACCOUNT_BILLING_ICP_REQUEST")) +
                "\n      "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row form-group" }, [
          _c("div", { staticClass: "col-sm-6" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("ACCOUNT_BILLING_TRANSCRIPTION_PRICING")) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-6" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm._f("currency")(_vm.pricingPlan.transcriptionCost)) +
                " /\n        " +
                _vm._s(_vm.$t("ACCOUNT_BILLING_TRANSCRIPTION_MINUTE")) +
                "\n      "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row form-group" }, [
          _c("div", { staticClass: "col-sm-6" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("ACCOUNT_BILLING_VOICE_AGENTS_PRICING")) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-6" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm._f("currency")(_vm.pricingPlan.ivaCost)) +
                " /\n        " +
                _vm._s(_vm.$t("ACCOUNT_BILLING_VOICE_AGENTS_MINUTE")) +
                "\n      "
            )
          ])
        ]),
        _vm._v(" "),
        _c("table", { staticClass: "table_beauty m-t-10" }, [
          _c("thead", [
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("COUNTRY")))]),
              _vm._v(" "),
              _c("th", [_vm._v("$/month (DID)")]),
              _vm._v(" "),
              _c("th", [_vm._v("$/month (TF)")]),
              _vm._v(" "),
              _c("th", [_vm._v("$/min (DID)")]),
              _vm._v(" "),
              _c("th", [_vm._v("$/min (TF)")])
            ])
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.formattedOverrides, function(override, index) {
              return _c("tr", { key: index }, [
                _c(
                  "td",
                  [
                    override.country !== "Default"
                      ? _c("CountryFlag", {
                          staticClass: "m-r-3",
                          attrs: { "country-code": override.country }
                        })
                      : _vm._e(),
                    _vm._v(
                      "\n            " +
                        _vm._s(override.country) +
                        "\n          "
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(override.numberPurchaseDID))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(override.numberPurchaseTF))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(override.costPerMinuteDID))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(override.costPerMinuteTF))])
              ])
            }),
            0
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }